import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>({
  wrapper: {
    width: '100%',
    [theme.breakpoints.down('sm')]:{
      
    }
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  title: {
    color: '#000',
    lineHeight: '18px',
    fontWeight: '500',
    marginBottom: '15px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      // marginBottom: '10px',
      // paddingTop:'15px'
     
    },
  },
  inputIndent: {
    marginBottom: '23px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '15px',
    },
  },
  currencyField: {
    width: '147px !important',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      paddingBlockStart: '20px',
    },
  },
  helpIcon: {
    fontSize: '19px',
    marginTop: '27px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      marginTop: '20px',
    },
  },
  multiSelectWrapper: {
    marginTop: '-10px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '0',
    },
  },
  imgContainer: {
    marginBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '10px',
    },
  },
}));
